<template>
  <vue-apex-charts
    ref="chartBar"
    type="bar"
    height="415"
    :series="series"
    :options="chartOptions"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'GraficoBarras',
  components: {
    VueApexCharts,
  },
  props: {
    dados: {
      type: Object,
      required: true,
    },
    categorias: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [{
        name: 'Concluídos',
        data: this.dados.concluidos,
      }, {
        name: 'Ação com Responsável',
        data: this.dados.acaoAuditar,
      }, {
        name: 'Ação com cliente',
        data: this.dados.acaoCliente,
      },
      ],
      chartOptions: {
        colors: ['rgba(95, 173, 86)', 'rgba(245, 183, 0)', 'rgba(214, 40, 57)'],
        chart: {
          type: 'bar',
          stacked: true,
          height: 415,
          events: {
            mounted: (chartContext, config) => {
              setTimeout(() => {
                this.addAnnotations(config)
              })
            },
            updated: (chartContext, config) => {
              setTimeout(() => {
                this.addAnnotations(config)
              })
            },
          },
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
            fontWeight: 500,
            colors: ['#fff'],
          },
        },
        noData: {
          text: 'Selecione um filtro',
          style: {
            color: getComputedStyle(document.documentElement).getPropertyValue('--chart-text-color').trim() || '#6e6b7b',
            fontSize: '14px',
            fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
          },
        },
        xaxis: {
          categories: this.categorias,
          labels: {
            show: true,
            style: {
              colors: getComputedStyle(document.documentElement).getPropertyValue('--chart-text-color').trim() || '#6e6b7b',
              fontSize: '12px',
              fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
              fontWeight: 500,
            },
          },
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: getComputedStyle(document.documentElement).getPropertyValue('--chart-text-color').trim() || '#6e6b7b',
              fontSize: '12px',
              fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
              fontWeight: 500,
            },
          },
        },
      },
    }
  },
  methods: {
    addAnnotations(config) {
      const seriesTotals = config.globals.stackedSeriesTotals
      if (this.$refs.chartBar) {
        this.$refs.chartBar.clearAnnotations()
      }

      if (this.$refs.chartBar) {
        const textColor = getComputedStyle(document.documentElement).getPropertyValue('--chart-text-color').trim() || '#6e6b7b'
        this.categorias.forEach((category, index) => {
          this.$refs.chartBar.addPointAnnotation(
            {
              y: seriesTotals[index],
              x: category,
              label: {
                text: `${seriesTotals[index].toLocaleString('pt-BR')}`,
                style: {
                  color: textColor,
                  background: 'transparent',
                  fontSize: '12px',
                  fontFamily: 'Montserrat, Helvetica, Arial, serif',
                  fontWeight: 500,
                },
              },
            },
            false,
          )
        })
      }
    },
  },
}
</script>
